export const permissionsTranslation = [
  "translation",
  "everything-full",
  "everything-readonly",
];
